import s from '../LoginPage/SocialButtons/SocialButtons.module.css'


export const authButtons=["forgot_password", "registration"]

export const socialButtons = [
    {label: "F", className: s.facebookButton},
    {label: "G", className: s.googleButton},
    {label: "VK", className: s.vkButton},
]
